// SocialLinks.js
import React from 'react';
import { Stack, IconButton, Tooltip } from '@mui/material';
import { LinkedIn, Twitter, Instagram, Facebook } from '@mui/icons-material';

const SocialLinks = ({ social }) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const extractHandle = (url) => {
    if (!url) return '';
    try {
      const path = new URL(url).pathname;
      return path.split('/').filter(Boolean)[0] || '';
    } catch {
      return '';
    }
  };

  const extractFacebookId = (url) => {
    if (!url) return '';
    try {
      const path = new URL(url).pathname.split('/').filter(Boolean);
      return path[path.length - 1] || '';
    } catch {
      return '';
    }
  };

  const openLink = (appUrl, webUrl) => {
    if (isMobile && appUrl) {
      window.location.href = appUrl;
      setTimeout(() => {
        window.open(webUrl, '_blank');
      }, 500);
    } else {
      window.open(webUrl, '_blank');
    }
  };

  const socialPlatforms = [
    { 
      name: 'LinkedIn', 
      icon: <LinkedIn />, 
      appUrl: social?.linkedin ? `linkedin://in/${extractHandle(social.linkedin)}` : null, 
      webUrl: social?.linkedin 
    },
    { 
      name: 'Twitter', 
      icon: <Twitter />, 
      appUrl: social?.twitter ? `twitter://user?screen_name=${extractHandle(social.twitter)}` : null, 
      webUrl: social?.twitter 
    },
    { 
      name: 'Instagram', 
      icon: <Instagram />, 
      appUrl: social?.instagram ? `instagram://user?username=${extractHandle(social.instagram)}` : null, 
      webUrl: social?.instagram 
    },
    { 
      name: 'Facebook', 
      icon: <Facebook />, 
      appUrl: social?.facebook ? `fb://profile/${extractFacebookId(social.facebook)}` : null, 
      webUrl: social?.facebook 
    }
  ];

  return (
    <Stack direction="row" spacing={1}>
      {socialPlatforms.map((platform) => (
        platform.webUrl && (
          <Tooltip key={platform.name} title={platform.name}>
            <IconButton
              onClick={() => openLink(platform.appUrl, platform.webUrl)}
              size="medium"
              sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" } }}
            >
              {platform.icon}
            </IconButton>
          </Tooltip>
        )
      ))}
    </Stack>
  );
};

export default SocialLinks;